import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2/icon';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import type {UndoRedoButtonsProps} from './undo-redo-buttons.types';
import styles from './undo-redo-buttons.module.scss';

export function UndoRedoButtons({actions, canUndo, canRedo}: UndoRedoButtonsProps): ReactElement {
  return (
    <>
      <Icon
        ariaLabel={window.i18next.t('pmwjs_undo')}
        className={styles.iconButton}
        icon="icon-rotate-ccw"
        isDisabled={!canUndo}
        isUsedAsButton
        onClick={(): void => {
          actions.undo();
        }}
        shape={IconShape.SQUARE}
        size={IconSize.SIZE_ICON_20}
        type={IconType.DARK_GHOST}
      />
      <Icon
        ariaLabel={window.i18next.t('pmwjs_redo')}
        className={styles.iconButton}
        icon="icon-rotate-cw"
        isDisabled={!canRedo}
        isUsedAsButton
        onClick={(): void => {
          actions.redo();
        }}
        shape={IconShape.SQUARE}
        size={IconSize.SIZE_ICON_20}
        type={IconType.DARK_GHOST}
      />
    </>
  );
}
